import { IsNotEmpty, IsNumber, IsDefined, Validate } from 'class-validator';

import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';
import { DisplayNameValidation } from 'src/core/customValidator/displayNameValidator';

export class TaxDataService extends DataService<typeof Model.General.Logic.ViewModels.TaxItem, Model.General.Logic.ViewModels.TaxItem, TaxItem> {
	protected map(entity: Model.General.Logic.ViewModels.TaxItem): TaxItem {
		return new TaxItemModel(entity);
	}

	public static make(ctx?: any): TaxDataService {
		return new TaxDataService(ctx, ctx => ctx.Taxs);
	}

	public add(defaultLanguage: string) {
		const entity = new Model.General.Logic.ViewModels.TaxItem();
		(entity as any).dynamicProperties['displayName'] = { [defaultLanguage]: '' };
		return entity;
	}
}

export class TaxItemModel extends EntityModel<Model.General.Logic.ViewModels.TaxItem, TaxItem> implements TaxItem {
	@property<TaxItemModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;

	@property<TaxItemModel>(o => o.entity.percent, (o, value) => o.entity.percent = value)
	@IsDefined({ message: 'percent is required' })
	public percent: number;

	@property<any>(o => o.entity.dynamicProperties, (o, value) => o.entity.dynamicProperties = value)
	@Validate(DisplayNameValidation, ['en'])
	public dynamicProperties: {};
}



// WEBPACK FOOTER //
// ./src/app/general/taxes/form/tax-form.data.ts